export function resolveRegion(r, timelines, tid, t) {
  if (r.start_t != null && t < r.start_t) return { ...r, hidden: true, activeStage: null };
  const byId = Object.fromEntries(timelines.map((x) => [x.id, x]));
  let best = null, bestKey = null, cur = tid, limit = t, depth = 0;
  const seen = new Set();
  while (cur && !seen.has(cur)) {
    seen.add(cur);
    for (const s of r.stages || []) {
      if (s.timeline_id !== cur || s.from_t > limit) continue;
      if (!bestKey || s.from_t > bestKey[0] || (s.from_t === bestKey[0] && depth < bestKey[1])) { best = s; bestKey = [s.from_t, depth]; }
    }
    const tl = byId[cur];
    if (!tl) break;
    if (tl.branch_point_timestamp != null) limit = Math.min(limit, tl.branch_point_timestamp);
    cur = tl.parent_timeline_id;
    depth += 1;
  }
  if (!best) return { ...r, hidden: false, activeStage: null };
  return { ...r, points: best.points, color: best.color, entity_id: best.entity_id, entity: best.entity, hidden: !!best.hidden, activeStage: best };
}

export function timeRange(regions, events) {
  const ts = events.map((e) => e.timestamp_int);
  regions.forEach((r) => { if (r.start_t != null) ts.push(r.start_t); (r.stages || []).forEach((s) => ts.push(s.from_t)); });
  if (!ts.length) return [0, 100];
  const lo = Math.min(...ts), hi = Math.max(...ts);
  return lo === hi ? [lo - 10, hi + 10] : [lo, hi];
}
